// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3rwnq","unreadBadge":"styles_unreadBadge__1itSY","modalContent":"styles_modalContent__2u-q_","modal":"styles_modal__kOTgn"};